export const LABELS = {
  LOADING: 'Loading...',
};

export default LABELS;
